module.exports = __webpack_public_path__ + "static/media/blank-config.4ecd8b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global/blank-config.png
// module id = 92
// module chunks = 0